import React from "react";
import "./ClaimOptions.css"; // optional for custom styles
import hand from "../../assets/img/claims/hand.svg";
import card_header from "../../assets/img/claims/card_header.svg";
import user from "../../assets/img/claims/user.svg";
import call from "../../assets/img/claims/call.svg";

const ClaimOptions = ({ responsiveStatus }) => {
  const claimOptions = [
    {
      icon: hand,
      title: "Digital Claims Portal",
      description: (
        <>
          If you have a policy with United Auto, you can now use our newly
          launched digital claims portal to file claims and track status updates{" "}
          <strong>24/7</strong> from any device.
        </>
      ),
      buttonText: "Start Here",
      url: "https://myclaim.uaig.net",
    },
    {
      icon: user,
      title: "Claim for Non Customers",
      description: (
        <>
          If you are not our customer, but were involved in an accident with an{" "}
          <strong>United Auto policyholder</strong>, you can now report claim
          online.
        </>
      ),
      buttonText: "Start Here",
      url: "https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims",
    },
    {
      icon: call,
      title: "Request Claim through calling",
      description: (
        <>
          You can also report your claim via our toll-free number during regular
          business hours by calling <br />
          <strong>(800)-344-2150</strong>.
        </>
      ),
      buttonText: "Call Now",
      url: "tel:800 344 2150",
    },
  ];

  return (
    <div
      className="container py-5"
      style={{ maxWidth: "1300px", margin: "0 auto" }}
    >
      <div
        className={`${
          responsiveStatus === "isDesktop"
            ? "text-center mb-4"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "text-center mb-4"
            : "text-left mb-4"
        }`}
      >
        {(responsiveStatus === "isMobile" ||
          responsiveStatus === "isSmallMobile") && (
          <p
            className="text-left mb-3"
            style={{ color: "#000", fontSize: "15px", fontWeight: "500" }}
          >
            <span
              style={{
                borderBottom: "2px solid #0E72D6",
                paddingBottom: "10px",
              }}
            >
              We’re here to help!
            </span>
          </p>
        )}

        {responsiveStatus !== "isMobile" &&
          responsiveStatus !== "isSmallMobile" && (
            <p
              className="text-center mb-3"
              style={{ color: "#000", fontSize: "15px", fontWeight: "500" }}
            >
              W
              <span
                style={{
                  borderBottom: "2px solid #0E72D6",
                  paddingBottom: "10px",
                }}
              >
                e’re here to he
              </span>
              lp!
            </p>
          )}

        <h2
          className={`${
            responsiveStatus === "isDesktop"
              ? "fw-bold"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "fw-bold"
              : "fw-bold-m"
          }`}
        >
          How do I report a claim?
        </h2>
        <p className="text-muted text-muted1">
          As a valued customer, filing a claim is quick and convenient through
          our app or website. Log in to your account, provide the required
          details, and track your claim status in real time. We’re here to make
          the process seamless and stress-free.
        </p>
      </div>
      <div className="row g-2">
        {claimOptions.map((option, idx) => (
          <div key={idx} className="col-md-4">
            <div
              className="card  shadow-sm border-1"
              style={{
                background: "linear-gradient(to bottom, #E1FAFF, #FFFFFF)",
                width: "95%",
                minHeight:
                  responsiveStatus === "isDesktop"
                    ? "300px"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "340px"
                    : "325px",
                maxWidth: "350px",
              }}
            >
              <div
                className="card-header1 d-block text-left"
                style={styles.container}
              >
                <div style={styles.backgroundOverlay}></div>
                <div style={styles.content}>
                  <img
                    src={option.icon}
                    alt="icon"
                    style={{ height: 40, marginBottom: 16 }}
                  />
                  <span className="card-title fw-bold">{option.title}</span>
                </div>
              </div>

              <div
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "card-body text-left mb-0"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "card-body text-left mb-0"
                    : "card-body1 text-left mb-0"
                }`}
              >
                <p
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "card-text1 text-muted mt-2"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "card-text1 text-muted mt-2"
                      : "card-text1 text-left text-muted1 mt-2 ml-2"
                  }`}
                >
                  {option.description}
                </p>
              </div>
              <div
                className="card-footer text-left"
                style={{ marginTop: "0px", marginLeft: "10px" }}
              >
                <a
                  href={option.url}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-style"
                  style={{ width: "105px", left: "12%" }}
                >
                  {option.buttonText}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#E1FAFF",
    maxWidth: "1300px",
    margin: "0 auto",
  },
  backgroundOverlay: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: `url(${card_header})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    opacity: 2.7, // semi-transparent image
    zIndex: 1,
    borderRadius: "0.45rem",
  },
  content: {
    position: "relative",
    zIndex: 2,
  },
};

export default ClaimOptions;
